export default "__VITE_ASSET__DrU1wCOm__"